import GridNoResultsSplash from './grid-no-results-splash';

export default GridNoResultsSplash;